import { Hall, HallFloor, HallRoom } from "../../interfaces";

export enum HallActionTypes {
  FETCH_HALLS_REQUEST = "@@hall/FETCH_HALLS_REQUEST",
  FETCH_HALLS_SUCCESS = "@@hall/FETCH_HALLS_SUCCESS",
  FETCH_HALLS_ERROR = "@@hall/FETCH_HALLS_ERROR",
  FETCH_HALL_REQUEST = "@@hall/FETCH_SINGLE_HALL_REQUEST",
  FETCH_HALL_SUCCESS = "@@hall/FETCH_SINGLE_HALL_SUCCESS",
  FETCH_HALL_ERROR = "@@hall/FETCH_SINGLE_HALL_ERROR",
  CREATE_HALL_REQUEST = "@@hall/CREATE_HALL_REQUEST",
  CREATE_HALL_SUCCESS = "@@hall/CREATE_HALL_SUCCESS",
  CREATE_HALL_ERROR = "@@hall/CREATE_HALL_ERROR",
  UPDATE_HALL_REQUEST = "@@hall/UPDATE_HALL_REQUEST",
  UPDATE_HALL_SUCCESS = "@@hall/UPDATE_HALL_SUCCESS",
  UPDATE_HALL_ERROR = "@@hall/UPDATE_HALL_ERROR",
  DELETE_HALL_REQUEST = "@@hall/DELETE_HALL_REQUEST",
  DELETE_HALL_SUCCESS = "@@hall/DELETE_HALL_SUCCESS",
  DELETE_HALL_ERROR = "@@hall/DELETE_HALL_ERROR",
  FETCH_HALL_ROOMS_REQUEST = "@@hall/FETCH_HALL_ROOMS_REQUEST",
  FETCH_HALL_ROOMS_SUCCESS = "@@hall/FETCH_HALL_ROOMS_SUCCESS",
  FETCH_HALL_ROOMS_ERROR = "@@hall/FETCH_HALL_ROOMS_ERROR",
  CLEAR_HALL_STATE = "@@hall/CLEAR_HALL_STATE",
}

export type HallState = {
  readonly isHallSubmitting: boolean;
  readonly isHallDeleting: boolean;
  readonly loading: boolean;
  readonly success: boolean;
  readonly failure: boolean;
  readonly error: any;
  readonly deleteSuccess: boolean;
  readonly halls: Hall[];
  readonly hall: Hall | null;
  readonly floors: HallFloor[];
  readonly floor: HallFloor | null;
  readonly rooms: HallRoom[];
  readonly room: HallRoom | null;
  readonly page: string;
  readonly isFloorSubmitting: boolean;
  readonly isFloorDeleting: boolean;
  readonly isRoomSubmitting: boolean;
  readonly isRoomDeleting: boolean;
};
